export default __webpack_public_path__ + "static/media/SP-13_tn.136e7f7a.jpg";